import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";
import { userUtil } from "../../utils";

import { FlexContainers } from "../../components";
import { InfoText, UserInfoContainer } from "./styled";

const UserLoginInfoTemplate = ({ email, createdAtTs, lastLoginTs }) => {
  return (
    <UserInfoContainer Container={FlexContainers.FlexRowStart} width={"100%"} wrap={"wrap"}>
      <InfoText>
        <b>{email}</b>
      </InfoText>

      {createdAtTs && (
        <InfoText
          dangerouslySetInnerHTML={{
            __html: t(strCode.CREATED_ON_INFO, {
              date: userUtil.formatUserLoginInfoTimestamp(createdAtTs)
            })
          }}
        />
      )}

      {lastLoginTs && (
        <InfoText
          dangerouslySetInnerHTML={{
            __html: t(strCode.LAST_LOGGED_IN_INFO, {
              date: userUtil.formatUserLoginInfoTimestamp(lastLoginTs)
            })
          }}
        />
      )}
    </UserInfoContainer>
  );
};

UserLoginInfoTemplate.propTypes = {
  email: PropTypes.string.isRequired,
  createdAtTs: PropTypes.number,
  lastLoginTs: PropTypes.number
};

export default UserLoginInfoTemplate;
